module.exports = __webpack_public_path__ + "img/blog-7-6.6b01469b.webp";